import { EpimsBaseEntityDto } from './epim-base.dto';
export class PipelineLicenseStakeholderDto extends EpimsBaseEntityDto {

    PipelineLicenseStakeholderId: string;

    PipelineLicenseStakeholderName: string;
    SubscriberId: string;
    SubscriptionUserId: string;
}